import React, {useState, useEffect} from 'react'

import Modal from 'react-bootstrap/Modal'
import {Button, Row, Col} from 'react-bootstrap'
import styles from './InventoryForm.module.css'

import ImagePreview from './ImagePreview';

function OldImages(props) {

    const [selectedImages, setSelectedImages] = useState([])

    const onImageSelect = (img)  => {

    }

    return (
    <Modal 
                className={props.modal_class !== undefined ? props.modal_class : ''}
                size="lg" 
                show={props.images.length > 0} 
                animation={false} 
                onHide={() => props.onClose('cancel')} 
            >
                <Modal.Header className={props.title_class !== undefined ? props.title_class : ''} closeButton>
                    <Modal.Title className={props.title_class !== undefined ? props.title_class : ''} >
                        <div className='d-flex inline-block align-items-center'>
                            {/* {!!props.icon && 
                                <>
                                <Icon /> 
                                <span>&nbsp;&nbsp;</span>
                                </>
                            } */}
                            {props.title}
                        </div>
                        </Modal.Title>
                </Modal.Header>
                <Modal.Body className={props.prompt_class !== undefined ? props.prompt_class : ''}>
                    <>
                    <div className='container-fluid row p-1 m-3 gx-1 too_old_images' >
                        { props.images.map((img, img_ix) => {
                                return (
                                    <Col key={img_ix} xxl={2} xl={2} lg={2} md={3} sm={4} xs={12} className={` ${styles.handle_overflow} `}>
                                        <ImagePreview 
                                            mode='preview'
                                            image={img} 
                                            onImageSelect={(img) => (img) }
                                            isImageSelected={selectedImages.indexOf(img) >= 0}
                                            overlayText='Too Old'
                                            overlayTextClassName='delete-overlay'
                                            // onImageAdded={newImageFileAdded}
                                        />
                                    </Col>
                                )
                            })
                        }
                    </div>
                    </>
                </Modal.Body>
                <Modal.Footer className={props.footer_class !== undefined ? props.footer_class : ''} >
                    {!!!props.confirm_only && ((props.cancel_button_text !== undefined && props.cancel_button_text !== '') || (props.cancel_button_text === undefined)) &&
                    <Button variant={props.cancel_button_variant !== undefined ? props.cancel_button_variant : 'secondary'} onClick={() => props.onClose('cancel')}>
                        {props.cancel_button_text !== undefined ? props.cancel_button_text : 'Cancel'}
                    </Button>
                    }
                </Modal.Footer>
            </Modal>
    )
}

export default OldImages
